export default __webpack_public_path__ + "static/media/InBetween.f457f3fe.png";